import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import Ratings from "react-ratings-declarative";
import LocationImage from "../../assets/images/Location2.png";
import call from "../../assets/images/Call.svg";
import mobile from "../../assets/images/MobileIcon.svg";
import "./ProfileUserFavorites.scss";

const ProfileUserFavorites = (props) => {
  return (
    <div className="ProfileUserFavorites">
      <div className="historyList">
        {props.data?.map((item, index) => {
          return (
            <div key={index} className="historyListItems">
              <div className="imageFigure">
                <img src={item.image} alt="historyListItem" />
              </div>
              <div className="leftInfo">
                <div className="item titleAndRate">
                  <p className="salonTitle">{item.salonTitle}</p>
                  <span className="rateWrapper">
                    <span className="rate">{item.rate}</span>
                    <Ratings
                      rating={item.rate}
                      widgetDimensions="20px"
                      widgetSpacings="1px"
                      widgetEmptyColor="grey"
                      wid
                    >
                      <Ratings.Widget widgetRatedColor="#FFB500" />
                      <Ratings.Widget widgetRatedColor="#FFB500" />
                      <Ratings.Widget widgetRatedColor="#FFB500" />
                      <Ratings.Widget widgetRatedColor="#FFB500" />
                      <Ratings.Widget widgetRatedColor="#FFB500" />
                    </Ratings>
                    <span className="rateTitle">امتیاز</span>
                  </span>
                </div>
                <span className="item salonAddress">
                  <img src={LocationImage} alt={item.salonAddress} className="salonIcon" />
                  {item.salonAddress}
                </span>
                <span className="item salonSuport">
                  <img src={call} alt={item.salonSuport} className="salonIcon" />
                  {item.salonSuport}
                </span>
                <div className="item mobileAndButton">
                  <span className="salonSuport">
                    <img src={mobile} alt={item.salonSuport} className="salonIcon" />
                    {item.salonPhone}
                  </span>
                  <button className="seeSalon">مشاهده سالن</button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default React.memo(withRouter(ProfileUserFavorites));
